<div class="px-3 pb-3">
    <div
        class="group relative flex items-center h-10 rounded-lg bg-white/10 ring-1 ring-inset ring-white/10 cursor-text transition-[background-color,box-shadow] duration-200 hover:bg-white/[0.14] focus-within:bg-white/[0.14] focus-within:ring-white/30"
        (click)="searchInput.focus()">
        <mat-icon
            class="ml-3 icon-size-5 text-white/50 transition-colors group-focus-within:text-white/90"
            [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
        <input
            #searchInput
            class="flex-1 min-w-0 h-full px-2.5 bg-transparent border-0 outline-none text-md font-medium text-white caret-white placeholder:text-white/40"
            type="text"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            role="combobox"
            aria-autocomplete="list"
            [attr.aria-label]="'codext.moduleSearchPlaceholder' | transloco"
            [attr.aria-expanded]="active()"
            [attr.aria-controls]="active() ? 'module-search-results' : null"
            [attr.aria-activedescendant]="
                active() && results().length
                    ? 'module-search-option-' + activeIndex()
                    : null
            "
            [placeholder]="'codext.moduleSearchPlaceholder' | transloco"
            [value]="query()"
            (input)="setQuery(searchInput.value)"
            (keydown)="onKeydown($event)" />
        @if (active()) {
            <button
                class="flex items-center justify-center w-7 h-7 mr-1.5 rounded-md text-white/60 transition-colors hover:text-white hover:bg-white/10"
                type="button"
                [attr.aria-label]="'codext.moduleSearchClear' | transloco"
                [matTooltip]="'codext.moduleSearchClear' | transloco"
                (click)="clear(); $event.stopPropagation()">
                <mat-icon
                    class="icon-size-4 text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        } @else {
            <kbd
                class="hidden md:inline-flex items-center h-5 px-1.5 mr-2.5 rounded border border-white/15 bg-white/5 font-sans text-xs font-medium leading-none tracking-wide text-white/45 select-none"
                aria-hidden="true">
                {{ shortcutLabel }}
            </kbd>
        }
    </div>
</div>

<ng-template #resultList>
    @if (active()) {
        <div
            class="sr-only"
            aria-live="polite">
            @if (results().length) {
                {{
                    'codext.moduleSearchResultCount'
                        | transloco: { count: results().length }
                }}
            } @else {
                {{
                    'codext.moduleSearchNoResults'
                        | transloco: { query: query().trim() }
                }}
            }
        </div>
        @if (results().length) {
            <div
                id="module-search-results"
                role="listbox"
                class="pb-2">
                @for (result of results(); track result.item; let i = $index) {
                    <div
                        data-result
                        role="option"
                        class="flex items-center gap-4 mx-3 mb-1 px-4 py-2.5 rounded-md cursor-pointer text-md font-medium text-white transition-colors duration-100"
                        [id]="'module-search-option-' + i"
                        [ngClass]="{ 'bg-white/[0.12]': i === activeIndex() }"
                        [attr.aria-selected]="i === activeIndex()"
                        (mousemove)="activeIndex.set(i)"
                        (click)="select(result)">
                        <mat-icon
                            class="shrink-0 icon-size-5 text-current transition-opacity"
                            [ngClass]="
                                i === activeIndex()
                                    ? 'opacity-100'
                                    : 'opacity-60'
                            "
                            [svgIcon]="
                                result.item.icon ??
                                'heroicons_outline:squares-2x2'
                            "></mat-icon>
                        <div class="flex-1 min-w-0">
                            <div class="truncate leading-5 text-white/90">
                                @for (part of result.parts; track $index) {
                                    <span
                                        [class.font-semibold]="part.match"
                                        [class.text-white]="part.match"
                                        [class.underline]="part.match"
                                        [class.decoration-2]="part.match"
                                        [class.decoration-white/40]="part.match"
                                        [class.underline-offset-2]="part.match"
                                        >{{ part.text }}</span
                                    >
                                }
                            </div>
                            @if (result.groupTitle) {
                                <div
                                    class="truncate text-xs leading-4 tracking-wider uppercase text-white/45">
                                    {{ result.groupTitle }}
                                </div>
                            }
                        </div>
                        @if (result.item.externalLink) {
                            <mat-icon
                                class="shrink-0 icon-size-4 text-white/40"
                                [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
                        } @else if (i === activeIndex()) {
                            <kbd
                                class="hidden md:inline-flex items-center h-5 px-1.5 rounded border border-white/15 bg-white/5 font-sans text-xs leading-none text-white/50 select-none"
                                aria-hidden="true">
                                ↵
                            </kbd>
                        }
                    </div>
                }
            </div>
        } @else {
            <div
                class="mx-3 px-4 py-6 rounded-lg border border-dashed border-white/15 text-center">
                <mat-icon
                    class="icon-size-6 text-white/35"
                    [svgIcon]="'heroicons_outline:face-frown'"></mat-icon>
                <div class="mt-2 text-md font-medium text-white/80">
                    {{
                        'codext.moduleSearchNoResults'
                            | transloco: { query: query().trim() }
                    }}
                </div>
                <div class="mt-1 text-sm leading-5 text-white/45">
                    {{ 'codext.moduleSearchNoResultsHint' | transloco }}
                </div>
            </div>
        }
    }
</ng-template>
